import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  id: "title",
  class: "relative"
}, "Galactic Alphabet Translator", -1)
const _hoisted_3 = {
  id: "panels",
  class: "relative"
}
const _hoisted_4 = {
  id: "translation",
  class: "relative blur"
}
const _hoisted_5 = { id: "output" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
        placeholder: "Write something here",
        class: "blur padding-3 border-box radius-2vh width-45 height-100 font-3vh relative"
      }, null, 512), [
        [_vModelText, _ctx.text]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translation), 1)
      ])
    ])
  ]))
}